import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "bodyField"]
  static values = { clientId: String }

  loadTemplate() {
    const templateId = this.selectTarget.value
    if (!templateId) return

    const target = this.bodyFieldTarget
    const isContentEditable = target.getAttribute("contenteditable") === "true"
    const currentContent = isContentEditable ? target.innerHTML.trim() : target.value.trim()

    // If target has content, confirm before replacing
    if (currentContent !== "" && currentContent !== "<br>") {
      if (!confirm("This will replace the current message body with the template. Continue?")) {
        this.selectTarget.value = ""
        return
      }
    }

    const clientId = this.clientIdValue || ""
    const url = `/admin/email_templates/${templateId}/resolve?client_id=${encodeURIComponent(clientId)}`

    fetch(url, {
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.body) {
        if (isContentEditable) {
          target.innerHTML = data.body
        } else {
          target.value = data.body
        }
        target.focus()
      }
    })
    .catch(error => {
      console.error("Failed to load template:", error)
    })

    // Reset the select so the same template can be re-selected
    this.selectTarget.value = ""
  }
}
